import { ACTIVE_USERS_LIST_TAG } from '@/api';
import { api } from '@/api';
import { UserRoleType } from '@/api';

export type UserEditResponse = { userId: string } | null;

export type UserStatus = 'Active' | 'Inactive';

export type UserEditProps = {
  name: string;
  role: UserRoleType;
  status: UserStatus;
  user_to_edit_id: string;
  user_id?: string;
  change_status_to: string;
  team_id?: string | null;
};

const userEditApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postUserEdit: builder.query<UserEditResponse, UserEditProps>({
      query: (props: UserEditProps) => {
        const params: Record<string, unknown> = {};
        Object.entries(props).forEach(([key, value]) => {
          if (value !== undefined) {
            params[key] = value;
          }
        });

        return {
          url: 'user/edit',
          method: 'POST',
          params,
        };
      },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        // Invalidate on any success: handleQueryLifecycle skips its callback when the body is null.
        try {
          await queryFulfilled;
        } catch {
          return;
        }

        dispatch(api.util.invalidateTags([ACTIVE_USERS_LIST_TAG]));
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyPostUserEditQuery } = userEditApi;
